import React from "react";
import { PersonalDataUpdateOcr } from "../../CustomPages";

// CustomScreenViewer props
export interface CustomScreenViewerProps {
  screen: string;
}

export const CustomScreenViewer: React.FC<CustomScreenViewerProps> = (props) => {
  switch (props.screen) {
    case "PersonalDataUpdateOcr":
      return <PersonalDataUpdateOcr />;
    default:
      return <div>NotFound [{props.screen}]</div>;
  }
};
